export var ExperienceData = [{
    "session": "2019-2020",
    "subject": "Internship",
    "institute": "ADN Edu-Service Ltd.",
    "paragraph": "This internship complete in deploma last semester, at first i learn about web design and my team members not interested in web design so at last internship complete with CCNA"
  }, {
    "session": "2020-2022",
    "subject": "System & Support Engineer",
    "institute": "Sorob It Ltd.",
    "paragraph": "This is the live link the company website https://www.sorobit.net my responsibility Website Design, Maintenance and manage the branch office 'Sorob it Ltd Uttara'"

  },{
    "session": "2021-2024",
    "subject": "Front-End Development",
    "institute": "Programming Hero & Other Online Platforms",
    "paragraph": "Self Learning, I try to learn real life project design and developer by help the online learning platform this protfolio site also the result of it"
  }];